import moment from 'moment'
import ThaiBaht from 'thai-baht-text' // for ES6
import Vue from 'vue'
import parsePhoneNumber from 'libphonenumber-js'
import i18n from '@/plugins/vue-i18n'
import TH from '../vue-i18n/locales/th-TH.json'
import LA from '../vue-i18n/locales/lo-LA.json'
class Helper {

  static get hashCurrency() {
    let data = {
      THB: {
        code: "THB",
        sign: "฿",
        text: i18n.t('baht'),
        textThEn: i18n.t('baht'),
        value: "THB",
        flag: "th",
        optionName: `${i18n.t('country.THA')} - THB`,
        tabName: `${i18n.t('country.THA')} - ${i18n.t('baht')}`
      },
      LAK: {
        code: "LAK",
        sign: "₭",
        text: i18n.t('kip'),
        textThEn: "LAK",
        value: "LAK",
        flag: "la",
        optionName: `${i18n.t('country.LAO')} - LAK`,
        tabName: `${i18n.t('country.LAO')} - LAK`
      },
      USD: {
        code: "USD",
        sign: "$",
        text: i18n.t('dollar'),
        textThEn: "USD",
        value: "USD",
        flag: "us",
        optionName: `${i18n.t('country.USA_short')} - USD`,
        tabName: `${i18n.t('country.USA')} - USD`
      }
    }
    return data
  }

  static ShowToastCatchError(error) {
    if (error && error.response && error.response.data && error.response.data.error) {
      return error.response.data.error || '-'
    } else if (error && error.message) {
      return error.message || '-'
    } else {
      return error || '-'
    }
  }
  static FormatNumberLength(num, length) {
    var r = "" + num;
    while (r.length < length) {
      r = "0" + r;
    }
    return r;
  }
  static toCurrency(n, _currencyCode, _options = {}) {
    const options = {
      isShowMinus: true,
      mathType: "inSide",
      ..._options
    };

    const cleanNumber = typeof n === 'string' ? n.replace(/,/g, '') : n;
    let num = parseFloat(cleanNumber);
    let isMinus = num < 0;
    let isZero = num == 0;

    if (isMinus && options.isShowMinus) {
      num = Math.abs(num);
    }

    let text = ""
    if (options.isAbbreviate) {
      text = this.formatNumberWithAbbreviation(num)
    } else if (options.isExchangeRate) {
      text = this.formatNumberWithCommas(this.toExchangeRate(num));
    } else {
      text = this.formatNumberWithCommas(num.toFixed(2));
    }

    if (options.isShowPlus && !isMinus && !isZero && options.mathType === "inSide") {
      text = `+${text}`;
    }
    if (options.isShowMinus && isMinus && !isZero && options.mathType === "inSide") {
      text = `-${text}`;
    }

    const currencyCode = _currencyCode || Vue.prototype.$globalCurrencyCode;
    text = this.formatCurrencyText(text, currencyCode, options);

    if (options.isShowPlus && !isMinus && !isZero && options.mathType === "outSide") {
      text = `+${text}`;
    }
    if (options.isShowMinus && isMinus && !isZero && options.mathType === "outSide") {
      text = `-${text}`;
    }
    return text;
  }
  static formatNumberWithAbbreviation(num) {
    if (num == Infinity) return "&#8734";
    const SI_SYMBOL = ["", "k", "M", "B", "T", "P", "E"];
    const tier = (Math.log10(Math.abs(num)) / 3) | 0;

    if (tier == 0) {
      if (num == 0) {
        return "0";
      }
      return this.formatNumberWithCommas(num.toFixed(2));
    }

    const suffix = SI_SYMBOL[tier];
    const scale = Math.pow(10, tier * 3);
    const scaled = num / scale;
    return scaled.toFixed(1) + suffix;
  }
  static formatCurrencyText(text, currencyCode, options) {
    const space = options.isNoSpace ? "" : " ";
    if (!currencyCode) return text;

    if (options.isSuffixCode && this.hashCurrency[currencyCode].code) {
      return `${text}${space}${this.hashCurrency[currencyCode].code}`;
    }
    if (options.isSuffixSign && this.hashCurrency[currencyCode].sign) {
      return `${text}${space}${this.hashCurrency[currencyCode].sign}`;
    }
    if (options.isPrefixCode && this.hashCurrency[currencyCode].code) {
      return `${this.hashCurrency[currencyCode].code}${space}${text}`;
    }
    if (options.isPrefixSign && this.hashCurrency[currencyCode].sign) {
      return `${this.hashCurrency[currencyCode].sign}${space}${text}`;
    }
    if (options.isSuffixText && this.hashCurrency[currencyCode].text) {
      const currencyText = options.isThEn ? this.hashCurrency[currencyCode].textThEn : this.hashCurrency[currencyCode].text;
      return `${text}${space}${currencyText}`;
    }
    return text;
  }
  static currencyText(currencyCode) {
    let _currencyCode = currencyCode || Vue.prototype.$globalCurrencyCode;
    return this.hashCurrency[_currencyCode]?.text
  }
  static currencyCode(currencyCode) {
    let _currencyCode = currencyCode || Vue.prototype.$globalCurrencyCode;
    return this.hashCurrency[_currencyCode]?.code
  }
  static currencySign(currencyCode) {
    let _currencyCode = currencyCode || Vue.prototype.$globalCurrencyCode;
    return this.hashCurrency[_currencyCode]?.sign
  }
  static currencyThEn(currencyCode) {
    let _currencyCode = currencyCode || Vue.prototype.$globalCurrencyCode;
    return this.hashCurrency[_currencyCode]?.textThEn
  }
  static currencyOptionName(currencyCode) {
    let _currencyCode = currencyCode || Vue.prototype.$globalCurrencyCode;
    return this.hashCurrency[_currencyCode]?.optionName
  }
  static get currencyOptions() {
    let currencySupports = Vue.prototype.$globalCurrencySupports
    let options = []
    for (let currencyCode of currencySupports) {
      options.push({
        name: this.hashCurrency[currencyCode].optionName,
        value: currencyCode,
        tabName: this.hashCurrency[currencyCode].tabName,
        textThEn: this.hashCurrency[currencyCode].textThEn
      })
    }
    return options
  }
  static toExchangeRate(number) {
    if (!number) return '0';
    
    // แปลงเป็น string เพื่อตรวจสอบจำนวนทศนิยม
    const numStr = number.toString();
    
    // หาตำแหน่งจุดทศนิยม
    const decimalIndex = numStr.indexOf('.');
    
    // ถ้าไม่มีทศนิยม return เลขจำนวนเต็ม + .0000
    if (decimalIndex === -1) return numStr + '.0000';
    
    // นับจำนวนตำแหน่งทศนิยม
    const decimalPlaces = numStr.length - decimalIndex - 1;
    
    // ถ้าน้อยกว่า 4 ตำแหน่ง เติมศูนย์ให้ครบ 4 ตำแหน่ง
    if (decimalPlaces < 4) {
      return number.toFixed(4);
    }
    
    // ถ้ามากกว่า 10 ตำแหน่ง ปัดเหลือ 10 ตำแหน่ง
    if (decimalPlaces > 10) {
      return Math.round(number * 10000000000) / 10000000000;
    }
    
    // แสดงตามจำนวนทศนิยมจริง
    return number.toString();
  }
  static toArabic(n) {
    if (n) {
      n = parseFloat(parseFloat(n).toFixed(2));
      if (n % 1 != 0)
        return n.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      else
        return n.toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      return '0';
    }
  }

  static splitArrayIntoChunks(arr, chunkLen) {
    var chunkList = []
    var chunkCount = Math.ceil(arr.length / chunkLen)
    for (var i = 0; i < chunkCount; i++) {
      chunkList.push(arr.splice(0, chunkLen))
    }
    return chunkList
  }
  static headerDateFormat(data) {
    if (data.split("-").length > 1)
      return this.$moment(data, "YYYY-MM").format("MMMM YYYY")
    else
      return data
  }
  static yearFormat(data) {
    return data
  }
  static datelabel(date) {
    if (date)
      return `${moment(date).format("D MMMM YYYY")}`;
    else
      return ``;
  }
  static formatWeekday(date) {
    const dayIndex = moment(date).day();
    const WeekdaysShort = moment.weekdaysMin();
    const WeekdaysShortNoDot = WeekdaysShort?.[dayIndex] ?? moment(date).format('dd');
    return WeekdaysShortNoDot.replace('.', '');
  }
  static formatMonth(date) {
    const m = moment(date);
    const monthIndex = m.month();
    const MonthsShort = moment.monthsShort();
    return MonthsShort?.[monthIndex] ?? m.format('MMM');
  }
  static dhm(s) {
    if (!s) return '0:0:0:0'
    const days = Math.floor(s / (24 * 60 * 60));
    const dayss = s % (24 * 60 * 60);
    const hours = Math.floor(dayss / (60 * 60));
    const hourss = s % (60 * 60);
    const minutes = Math.floor(hourss / (60));
    const minutess = s % (60);
    const sec = Math.floor(minutess);
    return days + ":" + hours + ":" + minutes + ":" + sec;
  }
  static roundNumber(num, n = 2) {
    let res = 0
    if (num)
      res = Math.round((num || 0) * (10 ^ n)) / (10 ^ n)
    return parseFloat(res.toFixed(n));
  }
  static round(num, isDecimal = true) {
    if (num)
      return isDecimal ? Math.round((num || 0) * 100) / 100 : Math.round(num || 0)
    return 0
  }
  static roundCurrency(num, isDecimal = true) {
    if (num)
      return isDecimal ? Math.round((num || 0) * 10000000000) / 10000000000 : Math.round(num || 0)
    return 0
  }
  static ceil(num, isDecimal = true) {
    if (num)
      return isDecimal ? Math.ceil((num || 0) * 100) / 100 : Math.ceil(num || 0)
    return 0
  }
  static roundFacilityCost(cost) {
    var a1 = Math.floor(cost);
    var a2 = 0;
    if (cost % 1 < 0.1) a2 = 0;
    else if (cost % 1 < 0.3) a2 = 0.25;
    else if (cost % 1 < 0.6) a2 = 0.5;
    else if (cost % 1 < 0.8) a2 = 0.75;
    else a2 = 1;
    return a1 + a2;
  }
  static numberToText(num) {
    var dg = [i18n.t('number_format.zero'), i18n.t('number_format.one'), i18n.t('number_format.two'), i18n.t('number_format.three'), i18n.t('number_format.four'), i18n.t('number_format.five'), i18n.t('number_format.six'), i18n.t('number_format.seven'), i18n.t('number_format.eight'), i18n.t('number_format.nine')];
    let text = ""
    let numInt;
    if (num || num == 0) {
      let tempNum = parseFloat(num)
      if (tempNum >= 0) {
        numInt = Math.floor(tempNum)
      } else {
        text = i18n.t('action_type.delete')
        numInt = Math.ceil(tempNum) * -1
      }
      text += ThaiBaht(numInt).split(i18n.t('payment.full_baht'))[0]
      let str = tempNum.toString()
      if (str.split('.') && str.split('.')[1]) {
        let strArray = str.split('.')[1].split('')
        text += `${i18n.t('dot')} ${strArray.map(d => { return dg[d] }).join('')}`
      }
    }
    return text || ""
  }
  static thaiBaht(num) {
    if (num || num == 0)
      return ThaiBaht(parseFloat(num))
    else
      return ""
  }
  static timeLabel(step = 30) {
    let stepLabel = [15, 30, 60]
    let hours = 24
    let minutes = 60

    let res = {
      hours: [],
      minutes: [],
      hoursMinutes: []
    }
    if (stepLabel.includes(step)) {
      for (let ih = 0; ih < hours; ih++) {
        res.hours.push(ih)
        let stepUp = 0
        for (let im = 0; im < minutes / step; im++) {
          res.minutes.push(stepUp)
          res.hoursMinutes.push(`${String(ih).padStart(2, '0')}:${String(stepUp).padStart(2, "0")}`)
          stepUp += step
        }
      }
    }
    return res
  }
  static queryMore(func, params, _limit, callbackFirst) {
    var objects = [];
    let fetchAllIgnoringLimit = async function (func, params, result) {
      const limit = _limit || 500;
      const skip = result.length;

      params = {
        ...params,
        limit,
        skip
      }

      const results = await func(params)
      if (callbackFirst) callbackFirst(results)
      result = result.concat(results)

      if (results.length === limit) {
        return await fetchAllIgnoringLimit(func, params, result);
      } else {
        return result;
      }
    }
    return fetchAllIgnoringLimit(func, params, objects)
  }
  static formatNumberLength(num, length) {
    var r = "" + num;
    while (r.length < length) {
      r = "0" + r;
    }
    return r;
  }
  static dayMonthYearText(startDate, endDate) {
    let days = 0;
    let months = 0;
    let years = 0;
    let text = "";
    if (startDate && endDate) {
      let a = moment(endDate);
      let b = moment(startDate);
      a.add(1, "days");
      years = a.diff(b, "year");
      b.add(years, "years");
      months = a.diff(b, "months");
      b.add(months, "months");
      days = a.diff(b, "days");
    }
    if (years) {
      text += `${years} ${i18n.t('year')} `;
    }
    if (months) {
      text += `${months} ${i18n.t('month')} `;
    }
    if (days) {
      text += `${days} ${i18n.t('day')}`;
    }
    return text;
  }

  static diffDays(startDate, endDate) {
    let days = 0;
    let minutes = 0;
    let end = endDate ? endDate : Date.now();
    if (end.iso) {
      end = end.iso;
    }
    if (startDate.iso && end) {
      minutes =
        moment(end).diff(moment(startDate.iso), "minutes") || 0;
      days = Math.ceil(minutes / (24 * 60));
    }
    return days;
  }
  static dateTimeTH(date) {
    return `${moment(date).format('DD MMM YYYY, HH:mm ' + i18n.t('timeunit.minute.short'))}`
  }
  static dateTH(date) {
    return `${moment(date).format('DD MMM YYYY')}`
  }
  static telToString(interTels = [], tels = [], options = {}) {
    let result = []
    if (interTels.filter(tel => tel && tel != "-").length) {
      for (let interTel of interTels.filter(tel => tel && tel != "-")) {
        let parsed = parsePhoneNumber(interTel)
        if (parsed?.isValid()) {
          let country = (parsed.country).toLowerCase()
          if (country != Vue.prototype.$globalLocale) {
            let prefix = `+${parsed.countryCallingCode}`
            result.push(`(${prefix})${parsed.nationalNumber}`)
          } else {
            result.push(`0${parsed.nationalNumber}`)
          }
        } else {
          result.push(interTel)
        }
      }
    } else if (tels.filter(tel => tel && tel != "-").length) {
      for (let tel of tels.filter(tel => tel && tel != "-")) {
        result.push(tel)
      }
    }
    return result.join(options.separator || ", ")
  }
  static get addressLocaleClass() {
    return Vue.prototype.$globalLocale != 'th' ? 'hide-autocomplete' : ''
  }
  static formatNumberWithCommas(numStr) {
    const parts = numStr.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join('.');
  }
  static get addressPrefix() {
    if (Vue.prototype.$globalLocale == 'la') {
      return {
        subDistrict: LA.messages.address.sub_district,
        district: LA.messages.address.district,
        province: LA.messages.address.province
      }
    } else {
      return {
        subDistrict: TH.messages.address.sub_district,
        district: TH.messages.address.district,
        province: TH.messages.address.province
      }
    }
  }
  static isImage(filename) {
    const validExtensions = [
      '.jpg',
      '.jpeg',
      '.png',
      '.gif',
      '.webp',
      '.svg',
      '.avif'
    ];
    const lowercaseFilename = filename.toLowerCase();
    return validExtensions.some(ext => lowercaseFilename.endsWith(ext));
  }
  static rules() {
    return {
      required: value => !!value || i18n.t('validate.please_input_data_another_format'),
      email: value => {
        const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return !value || pattern.test(value) || i18n.t('validate.please_input_email_correct');
      },
    }
  }
}


export default Helper